export type ZeroResult = { type: string; error?: unknown };

function isUserFacingError(error: unknown): boolean {
  return (
    error != null &&
    typeof error === "object" &&
    "details" in error &&
    (error as { details?: { userFacing?: boolean } }).details?.userFacing ===
      true
  );
}

function isZeroLifecycleError(error: unknown): boolean {
  if (error == null || typeof error !== "object") return false;
  const e = error as { type?: string; details?: { kind?: string } };
  return e.type === "zero" || e.details?.kind === "ClientClosed";
}

function errorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (
    error != null &&
    typeof error === "object" &&
    "message" in error &&
    typeof (error as { message: unknown }).message === "string"
  ) {
    return (error as { message: string }).message;
  }
  return JSON.stringify(error);
}

export type ZeroResultDecision =
  | { kind: "ignore" }
  | { kind: "toast"; message?: string };

export function classifyZeroResult(result: ZeroResult): ZeroResultDecision {
  if (result.type !== "error") return { kind: "ignore" };
  if (isZeroLifecycleError(result.error)) return { kind: "ignore" };
  if (isUserFacingError(result.error)) {
    return { kind: "toast", message: errorMessage(result.error) };
  }
  return { kind: "toast" };
}
